import { xml2json } from 'xml2json-light';
import axios from '@/api/axiosInstance';
import { getSpritesData } from '@/shared/GameComponents/GameAssetsContext/spriteSheetparser/classicSpriteSheetParser';
import * as Sentry from '@sentry/nextjs';
import getXMLAsJSON from '@/api/content/getXMLAsJSON.endpoint';

export async function parseXMLSpriteSheets(gameData, gameAssetsFolder) {
  const spriteSheet = gameData.spritesheet;
  const spriteSheetImage = `${gameAssetsFolder}/textureAtlas/${spriteSheet}.${
    gameData.spritesheetImgFormat ?? 'png'
  }`;
  const spriteSheetXML = `${gameAssetsFolder}/textureAtlas/${spriteSheet}.xml`;
  let spriteSheetResponse;
  let jsonSpriteSheet;
  try {
    spriteSheetResponse = await getXMLSpriteSheet(spriteSheetXML);
    jsonSpriteSheet = xml2json(spriteSheetResponse.data);
  } catch (error) {
    try {
      jsonSpriteSheet = await getXMLAsJSON(spriteSheetXML);
    } catch (secondError) {
      Sentry.captureException(error);
      Sentry.captureException(secondError);
      throw new Error(
        "We weren't able to load the game assets. Please try again later."
      );
    }
  }

  const spriteSheetData = getSpritesData(
    jsonSpriteSheet.TextureAtlas.SubTexture,
    spriteSheetImage
  );
  //console.log('[ spriteSheetData ]', spriteSheetData);

  return spriteSheetData;
}

async function getXMLSpriteSheet(spriteSheetXML) {
  return axios.get(spriteSheetXML, {
    'Content-Type': 'application/xml; charset=utf-8',
  });
}
